{
  "it": {
    "markdownEditor": {
      "toolbar": "Formattazione",
      "bold": "Grassetto",
      "italic": "Corsivo",
      "heading": "Titolo",
      "bulletList": "Elenco puntato",
      "orderedList": "Elenco numerato",
      "center": "Centra",
      "details": "Sezione comprimibile",
      "detailsCollapse": "Comprimi la sezione",
      "detailsExpand": "Espandi la sezione",
      "link": "Link",
      "linkUrl": "Indirizzo del link",
      "linkUrlPlaceholder": "https://…",
      "linkApply": "Applica",
      "linkRemove": "Rimuovi link",
      "linkInvalid": "Si possono collegare solo indirizzi http(s) o percorsi di questo sito.",
      "image": "Immagine",
      "imageAlt": "Descrizione dell'immagine",
      "imageApply": "Inserisci",
      "close": "Chiudi",
      "source": "Modifica il sorgente Markdown",
      "imageUploadFailed": "Impossibile caricare l'immagine. Riprova.",
      "imageTitle": "Inserisci un'immagine",
      "imageAltHint": "Letta al posto dell'immagine e mostrata se non può essere caricata.",
      "cancel": "Annulla",
      "imageSize": "Dimensione dell'immagine",
      "imageSize25": "Piccola",
      "imageSize50": "Media",
      "imageSize75": "Grande",
      "imageSizeFull": "Larghezza piena",
      "item": "Voce del catalogo",
      "itemSearchHint": "Digita il nome di una voce",
      "itemSearchEmpty": "Nessuna voce elencata con quel nome",
      "itemType": {
        "Component": "Componente",
        "Equipment": "Equipaggiamento",
        "Commodity": "Merce",
        "Model": "Nave",
        "Blueprint": "Progetto",
        "GameMission": "Missione",
        "Location": "Luogo",
        "FleetContract": "Contratto",
        "FleetEvent": "Evento",
        "User": "Utente"
      }
    }
  }
}
